module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "c-box"
  }, [_c('header', {
    staticClass: "c-box__heading",
    on: {
      "click": _vm.toggleVariationInfo
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "u-floatRight",
    class: _vm.toggleIconClass()
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "c-box__body"
  }, [_c('div', {
    staticClass: "c-box__inner"
  }, [_c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('gender.label'),
      "columns": 4,
      "error": _vm.getErrorBySku('gender', _vm.variation.sku)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.gender),
      expression: "variation.gender"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.variation, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("\n                  Selecione\n                ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('gender.male.label')) + "\n                ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('gender.female.label')) + "\n                ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unisex"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('gender.unisex.label')) + "\n                ")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('crossDocking.label'),
      "columns": 4,
      "error": _vm.getErrorBySku('crossDocking', _vm.variation.sku)
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.crossDocking),
      expression: "variation.crossDocking"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.variation.crossDocking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "crossDocking", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("dias")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('manufacturerReference.label'),
      "columns": 4,
      "error": _vm.getErrorBySku('manufacturerReference', _vm.variation.sku)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.manufacturerReference),
      expression: "variation.manufacturerReference"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.variation.manufacturerReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "manufacturerReference", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('product-provide-image', {
    attrs: {
      "variation": _vm.variation
    }
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.variationTitle()))])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0bd91a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductProvide/Edit/Tiny/Variation.vue
// module id = 3440
// module chunks = 0